import { call, put, takeEvery, select } from "redux-saga/effects";
import { invoiceTemplateLoader, setInvoiceTemplateList } from "./actions";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import {
  GET_INVOICES_TEMPLATE_LIST,
  ADD_INVOICE_TEMPLATE,
  UPDATE_INVOICE_TEMPLATE,
  DELETE_INVOICE_TEMPLATE,
} from "./actionTypes";
import {
  getInvoiceTemplates,
  postInvoiceTemplates,
  delInvoiceTemplates,
  patchInvoiceTemplates,
} from "../../helpers/jwt_helper";

function* onGetInvoiceTemplateList({ payload: data }) {
  try {
    yield put(invoiceTemplateLoader());
    let response = yield call(getInvoiceTemplates, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
        description: i.description === "string" ? "" : i.description,
      })),
    };
    yield put(setInvoiceTemplateList(response));
    yield put(invoiceTemplateLoader());
  } catch (error) {
    yield put(invoiceTemplateLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteInvoiceTemplate({ payload: id }) {
  try {
    let currentData = yield select(state => state.InvoiceTemplates.data);
    yield put(invoiceTemplateLoader());
    yield call(delInvoiceTemplates, id);
    yield call(onGetInvoiceTemplateList, { payload: currentData });
    yield put(invoiceTemplateLoader());
    showSuccessMessage("Invoice template has been deleted");
  } catch (error) {
    yield put(invoiceTemplateLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddInvoiceTemplate({ payload: data }) {
  try {
    let currentData = yield select(state => state.InvoiceTemplates.data);
    yield put(invoiceTemplateLoader());
    yield call(postInvoiceTemplates, data);
    yield call(onGetInvoiceTemplateList, { payload: currentData });
    showSuccessMessage("Invoice template has been added");
    yield put(invoiceTemplateLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(invoiceTemplateLoader());
  }
}

function* onUpdateInvoiceTemplate({ payload: { id, data } }) {
  try {
    yield put(invoiceTemplateLoader());
    yield call(patchInvoiceTemplates, id, data);
    yield call(onGetInvoiceTemplateList, { payload: data });
    yield put(invoiceTemplateLoader());
    showSuccessMessage("Invoice template has been updated");
  } catch (error) {
    yield put(invoiceTemplateLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* invoiceTemplatesSaga() {
  yield takeEvery(GET_INVOICES_TEMPLATE_LIST, onGetInvoiceTemplateList);
  yield takeEvery(DELETE_INVOICE_TEMPLATE, onDeleteInvoiceTemplate);
  yield takeEvery(ADD_INVOICE_TEMPLATE, onAddInvoiceTemplate);
  yield takeEvery(UPDATE_INVOICE_TEMPLATE, onUpdateInvoiceTemplate);
}

export default invoiceTemplatesSaga;
